module.exports = __webpack_public_path__ + "img/tarjeta_atencion_cliente_mediado.46aa5982.jpg";